// navigateHelper.js
let navigateFunction;
export const setNavigate = (navigate) => {
    navigateFunction = navigate;
};
export const navigateTo = (path) => {
    if (navigateFunction) {
        navigateFunction(path);
    }
};